import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { visibleSections } from './navConfig';
import { Avatar } from '../ui/UserCell';
import IconButton from '../ui/IconButton';
import StaarvaniLogo from '../../images/staarvani.png';
import StaarvaniMark from '../../images/staarvani_mobile_logo.png';
import './shell.css';

/**
 * 248px grouped sidebar. Attention badges come from the dashboard attention-counts
 * payload, keyed by each nav item's `badge` field.
 */
export default function Sidebar({ counts = {}, onSignOut, collapsed = false }) {
  const activeUser = useSelector((state) => state.auth?.active_user?.data);
  const roles = activeUser?.roles || [];
  const sections = visibleSections(roles);

  const fullName = [activeUser?.first_name, activeUser?.last_name].filter(Boolean).join(' ');
  const roleLabel = roles.includes('super_admin')
    ? 'Super Admin'
    : roles.map((r) => r.replace(/_/g, ' ')).join(', ') || '—';

  return (
    <aside className={`sv-sidebar ${collapsed ? 'is-collapsed' : ''}`}>
      <div className="sv-sidebar__brand">
        <img
          src={collapsed ? StaarvaniMark : StaarvaniLogo}
          alt="Staarvani"
          className="sv-sidebar__logo"
        />
      </div>

      <nav className="sv-sidebar__nav" aria-label="Main">
        {sections.map((section) => (
          <div key={section.label} className="sv-nav-section">
            {!collapsed && <div className="sv-nav-section__label">{section.label}</div>}
            {section.items.map((item) => {
              const badge = item.badge ? counts[item.badge] : null;
              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) => `sv-nav-item ${isActive ? 'is-active' : ''}`}
                  title={collapsed ? item.label : undefined}
                >
                  <i className={`bx ${item.icon}`} aria-hidden="true" />
                  {!collapsed && <span className="sv-nav-item__label">{item.label}</span>}
                  {!collapsed && badge > 0 && (
                    <span className="sv-nav-item__badge is-attention">{badge}</span>
                  )}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>

      <div className="sv-sidebar__foot">
        <Avatar name={fullName || 'Admin'} seed={activeUser?.id} size={32} fontSize={12} />
        {!collapsed && (
          <div className="sv-sidebar__user">
            <div className="sv-sidebar__user-name sv-truncate">{fullName || 'Admin'}</div>
            <div className="sv-sidebar__user-role sv-truncate">{roleLabel}</div>
          </div>
        )}
        <IconButton icon="bx-log-out" size="sm" label="Sign out" onClick={onSignOut} />
      </div>
    </aside>
  );
}
